import { createStateHook } from 'react-sweet-state';
import { store } from '../../main';
export var useLastProcessedChange = createStateHook(store, {
  // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
  // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
  // will not change on consecutive updates to a given field but the reference will)
  // https://github.com/atlassian/react-sweet-state/issues/167
  selector: function selector(state) {
    return {
      lastProcessedChange: state.lastProcessedChange
    };
  }
});